
const digest = '0fb9da71008eac5ef8e0351b8e8bcb6529438d2fc020eafab8fa9de95a6315e1';
const classes = {"wrapper":"_wrapper_1xl3x_1","value":"_value_1xl3x_12","diff":"_diff_1xl3x_18"};
const css = `._wrapper_1xl3x_1 {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  border-top: 0;
}

._value_1xl3x_12 {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

._diff_1xl3x_18 {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  